import React from 'react';

import pinkBellIcon from '../../../assets/img/pinkBell.png';
import purpleBellIcon from '../../../assets/img/purpleBell.png';

function ActionIcons(props) {
  const isAssigned = props.item.clinician_id === props.clinician_id;
  if (
    props.item &&
    ((props.item.showInSimple && props.isSimple) ||
      (props.item.showInComplex && !props.isSimple)) &&
    ((props.item.showInExpanded && props.isExpanded) ||
      (props.item.showInCollapsed && !props.isExpanded))
  )
    return (
      <div className={props.item.type + '-container'}>
        {isAssigned ? (
          <img
            src={pinkBellIcon}
            alt={props.item.type}
            className={`${props.item.type}-icon`}
          ></img>
        ) : (
          <img
            src={purpleBellIcon}
            alt={props.item.type}
            className={`${props.item.type}-icon`}
          ></img>
        )}
      </div>
    );
  else return null;
}

export { ActionIcons };
